import React from 'react';
import './Navbar.css';
import { NavLink , Link} from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import siteConfig from '../../resources/data/config.js';
import logo from '../../resources/assets/logo512.png';

function JSCNavbar() {
  return (
    <Navbar expand="lg" className="jsc-navbar">
      <Container>
        {/* Brand Logo */}
        <Navbar.Brand as={NavLink} to="/"><img src={logo} alt="Logo" className="navbar-logo" loading="lazy" height="100" width="100"/></Navbar.Brand>

        {/* Brand Name linking to Home */}
        <Navbar.Brand as={NavLink} to="/">{siteConfig.name}</Navbar.Brand>

        {/* Toggle for mobile view */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Navigation Links */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/">Home</Nav.Link>
            <Nav.Link as={NavLink} to="/services">Services</Nav.Link>
            <Nav.Link as={NavLink} to="/recommendations">Recommendations</Nav.Link>

            {/* Dropdown for Socials */}
            <NavDropdown title="Socials" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to={siteConfig.social.instagram} target="_blank">Instagram</NavDropdown.Item>
            </NavDropdown>
            
            
            <Nav.Link as={NavLink} to="/testimonials">Testimonials</Nav.Link>
            <Nav.Link as={NavLink} to="/contact">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default JSCNavbar;